// extracted by mini-css-extract-plugin
module.exports = {"current-appeals-compact-block-slider":"CurrentAppealsCompactBlock_current-appeals-compact-block-slider__qMjsW"};